export default [
	{
		path: '/solution/uci-enterprise',
		name: 'uciEnterprise',
		meta: {
			title: '城投企业',
			title2: '城投企业-华略未来科技',
		},
		component: () => import('views/solution/uciEnterprise/uciEnterprise.vue'),
	},
	{
		path: '/solution/e-ms-bureau',
		name: 'eMsBureau',
		meta: {
			title: '教育局/市监局',
			title2: '教育局/市监局-华略未来科技',
		},
		component: () => import('views/solution/eAndMsBureau/eAndMsBureau.vue'),
	},
];

